import React, { useContext, useEffect } from 'react'
import Script from 'next/script'
import { PageContext } from '@contexts/page-context'
import { useGnarContainerId, useUserService } from '@lib/hooks'
import { getLocalStorageItem, LocalStorageKey } from '@lib/utils/local-storage'
import { getConfig } from '../../../config'
import { PROFESSIONAL_TOOL_NEW_SLUGS } from '@lib/constants'
import { Cookie, getCookie } from '@lib/utils/cookies'

declare global {
  interface Window {
    Sprig?: (command: string, ...args: unknown[]) => void
  }
}

const sprigEnvironmentId = getConfig().tracking.sprig.environmentId
const enabledOnPages = [
  'ai-humanizer',
  'grammar-check',
  'plagiarism-checker',
  'paraphrasing-tool',
  'ai-detector',
  ...PROFESSIONAL_TOOL_NEW_SLUGS,
]
const sprigCode = `
          (function(l,e,a,p) {
            if (window.Sprig) return;
            window.Sprig = function(){S._queue.push(arguments)}
            var S = window.Sprig;S.appId = a;S._queue = [];window.UserLeap=S;
            a=l.createElement('script');
            a.async=1;a.src=e+'?id='+S.appId;
            p=l.getElementsByTagName('script')[0];
            p.parentNode.insertBefore(a, p);
          })(document, 'https://cdn.sprig.com/shim.js', '${sprigEnvironmentId}');
        `

export const SprigScript: React.FC = () => {
  const { slug } = useContext(PageContext)
  const { currentUser } = useUserService()
  const { containerId } = useGnarContainerId()
  const sessionId = getCookie(Cookie.gnarWebsiteSessionId)

  useEffect(() => {
    if (typeof window !== 'undefined' && window.Sprig) {
      const sprigDataRaw = getLocalStorageItem(LocalStorageKey.sprigUserIds)
      let hasSprigUserId = false

      try {
        const sprigData = JSON.parse(sprigDataRaw || '{}')
        const envData = sprigData?.[sprigEnvironmentId]
        hasSprigUserId = !!envData?.uid
      } catch (e) {
        console.error('Error parsing sprig data:', e)
      }

      if (!currentUser.isAnonymous && currentUser.id) {
        window.Sprig('setUserId', currentUser.id.toString())
      } else if (currentUser.isAnonymous && hasSprigUserId) {
        window.Sprig('logoutUser')
      }

      window.Sprig('setAttribute', 'CONTAINER_ID', containerId)
      if (sessionId) {
        window.Sprig('setAttribute', 'SESSION_ID', sessionId)
      }
    }
  }, [currentUser.isAnonymous, currentUser.id, sessionId, containerId])

  if (!enabledOnPages.includes(slug)) {
    return null
  }

  return <Script strategy="afterInteractive" dangerouslySetInnerHTML={{ __html: sprigCode }} />
}
